/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2021
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // getModuleObject, updatePropertyOverride

/**
 * Static utility APIs to support MoserObject
 * @author  linzhao
 */
export default class MoserObjectUtils extends BaseMoserObject{

	static ID_SEPARATOR = ".";



	/**
	 * We have to treat PropertyType differently for WA data asset shaping For any new or updated PropertyType, the ObjectType will have an entry like 'Property.{name}' in its propertyOverride
	 * @param {MoserObject} objType  the parent of the PropertyType
	 * @param {PropertyType} item  the changed/new PropertyType
	 */
	static propertyOverrideForPropertyType(objType, item) {
		if (objType && objType instanceof ObjectType) {
			var obj = objType;
			var module = MoserObject.getModuleObject(objType);
			if (module && module.isOverrideMode() && item.getName() != null) {
				MoserObjectUtils._setPropertyOverride(obj.getFeatureName(87) + "." + item.getName(), obj);
			}
		}
	}

	/**
	 * We have to treat LocalRefType differently for WA data asset shaping For any changes in LocalRefType, the ItemHierarchy will have an entry like 'LocalRef' in its propertyOverride
	 * @param {MoserObject} itemHierarchy
	 */
	static propertyOverrideForLocalRef(itemHierarchy) {
		if (itemHierarchy && itemHierarchy instanceof ObjectType) {
			var obj = itemHierarchy;
			var module = MoserObject.getModuleObject(itemHierarchy);
			if (module && module.isOverrideMode()) {
				MoserObjectUtils._setPropertyOverride(obj.getFeatureName(73), obj);
			}
		}
	}

	static propertyOverrideForTaxonomyType(taxonomyObj) {
		var objType = MoserObjectUtils._getObjectTypeParent(taxonomyObj);
		if (objType) {
			MoserObject.updatePropertyOverride(objType, objType, 246, false);
		}
	}

	/**
	 * To support updating facet definition related properties in embedded module, we have to add the propertyOverride of the parent object (QueryItem) with 'facetDefinition'
	 * @param {MoserObject} facetObj
	 * @param  isAdd
	 */
	static propertyOverrideForFacetType(facetObj) {
		var objType = MoserObjectUtils._getObjectTypeParent(facetObj);
		if (objType) {
			MoserObject.updatePropertyOverride(objType, objType, 249, false);
		}
	}

	static _getObjectTypeParent(obj) {
		if (!obj) {
			return null;
		}
		if (obj instanceof ObjectType) {
			return obj;
		}
		return MoserObjectUtils._getObjectTypeParent(obj.getParent());
	}

	static _setPropertyOverride(featureName, obj) {
		var overrideList = MoserObjectUtils.getList(obj.basicGetPropertyOverride());
		for (var __i_enFor0 = 0, __exp_enFor0 = overrideList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var override = __exp_enFor0[__i_enFor0];
			if (override == featureName || "NEW" == override) {
				return;
			}
		}
		obj.addPropertyOverride(featureName);
	}

	static getQueryItems$0(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getQueryItem()) {
				qItems.push(item.getQueryItem());
			} else if (item.getFolder()) {
				Array.prototype.push.apply(qItems, MoserObjectUtils.getQueryItems$0(item.getFolder().basicGetItem()));
			}
		}
		return qItems;
	}

	static getQueryItems$1(qs) {
		return MoserObjectUtils.getQueryItems$0(qs.basicGetItem());
	}

	static getFilters$0(items) {
		var filters = [];
		if (!items) {
			return filters;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getFilter()) {
				filters.push(item.getFilter());
			} else if (item.getFolder()) {
				Array.prototype.push.apply(filters, MoserObjectUtils.getFilters$0(item.getFolder().basicGetItem()));
			}
		}
		return filters;
	}

	static getFilters$1(qs) {
		return MoserObjectUtils.getFilters$0(qs.basicGetItem());
	}

	/**
	 * Return all FolderType in the MDTV as a flat list
	 * @param {Module} module
	 * @return {Array}
	 */
	static getFolderTypes(module) {
		var qFolders = [];
		var folders = module.basicGetMetadataTreeView();
		if (folders) {
			for (var __i_enFor0 = 0, __exp_enFor0 = folders, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var folder = __exp_enFor0[__i_enFor0];
				qFolders.push(folder);
				MoserObjectUtils._collectFolderTypes(qFolders, folder.basicGetFolderItem());
			}
		}
		return qFolders;
	}

	/**
	 * @param {Array} qFolders
	 * @param {Array} folderItems
	 * @return {void}
	 */
	static _collectFolderTypes(qFolders, folderItems) {
		if (folderItems) {
			for (var __i_enFor0 = 0, __exp_enFor0 = folderItems, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var folderItem = __exp_enFor0[__i_enFor0];
				var folder = folderItem.getFolder();
				if (folder) {
					qFolders.push(folder);
					MoserObjectUtils._collectFolderTypes(qFolders, folder.basicGetFolderItem());
				}
			}
		}
	}

	/**
	 * Retrieve all items of type 'Filter/Folder/ItemHierarchy/NamedSet/QueryItem/Calculation' under a 'QuerySubject/QueryItem/Folder'
	 * @param {ObjectType} obj
	 * @return {Array}
	 */
	static getItems(obj) {
		var qItems = [];
		var objectType = obj.getObjectType();
		if ("QuerySubject" == objectType) {
			MoserObjectUtils._collectItems(qItems, (obj).basicGetItem());
		} else if ("QueryItem" == objectType) {
			MoserObjectUtils._collectItems(qItems, (obj).basicGetItem());
		} else if ("Folder" == objectType) {
			MoserObjectUtils._collectItems(qItems, (obj).basicGetItem());
		}
		return qItems;
	}

	/**
	 * Collect all items of an ItemType list into a list.
	 * @param {Array} allItems
	 * @param {Array} items
	 */
	static _collectItems(allItems, items) {
		if (items) {
			for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var item = __exp_enFor0[__i_enFor0];
				if (item.getFilter()) {
					allItems.push(item.getFilter());
				} else if (item.getFolder()) {
					var f = item.getFolder();
					allItems.push(f);
					MoserObjectUtils._collectItems(allItems, f.basicGetItem());
				} else if (item.getItemHierarchy()) {
					allItems.push(item.getItemHierarchy());
				} else if (item.getNamedSet()) {
					allItems.push(item.getNamedSet());
				} else if (item.getCalculation()) {
					var calc = item.getCalculation();
					allItems.push(calc);
					MoserObjectUtils._collectItems(allItems, calc.basicGetItem());
				} else if (item.getQueryItem()) {
					var qi = item.getQueryItem();
					allItems.push(qi);
					MoserObjectUtils._collectItems(allItems, qi.basicGetItem());
				}
			}
		}
	}

	static _removeQueryItem$0(items, qi) {
		if (!items) {
			return;
		}
		var id = qi.getIdentifier();
		for (var i = items.length - 1; i >= 0; --i) {
			var item = items[i];
			var qitem = item.getQueryItem();
			if (qitem && qitem.getIdentifier() == id) {
				items.splice(i, 1);
				break;
			} else if (item.getFolder()) {
				MoserObjectUtils._removeQueryItem$0(item.getFolder().basicGetItem(), qi);
				var folderItems = item.getFolder().basicGetItem();
				if (!folderItems || folderItems.length==0) {
					items.splice(i, 1);
				}
			}
		}
	}

	static removeQueryItem$1(qs, qi) {
		MoserObjectUtils._removeQueryItem$0(qs.basicGetItem(), qi);
	}

	static getMeasures$0(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getQueryItem()) {
				qItems.push(item.getQueryItem());
				Array.prototype.push.apply(qItems, MoserObjectUtils.getMeasures$0(item.getQueryItem().basicGetItem()));
			} else if (item.getFolder()) {
				Array.prototype.push.apply(qItems, MoserObjectUtils.getMeasures$0(item.getFolder().basicGetItem()));
			}
		}
		return qItems;
	}

	static getMeasures$1(qs) {
		return MoserObjectUtils.getMeasures$0(qs.basicGetItem());
	}

	static getItemNormalizationGroups(qs) {
		var rt = [];
		var itemNormalization = qs.getItemNormalization();
		if (!itemNormalization) {
			return rt;
		}
		var grps = itemNormalization.basicGetItemNormalizationGroup();
		if (grps) {
			Array.prototype.push.apply(rt, grps);
		}
		return rt;
	}

	static getList(lst) {
		var rt = lst;
		if (!rt) {
			rt = [];
		}
		return rt;
	}

	static getQueryItems(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getQueryItems$0(a0);
		}
		return MoserObjectUtils.getQueryItems$1(a0);
	}

	static getFilters(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getFilters$0(a0);
		}
		return MoserObjectUtils.getFilters$1(a0);
	}

	static removeQueryItem(a0, a1) {
		var args = arguments;
		if (args.length == 2 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.removeQueryItem$0(a0, a1);
		}
		return MoserObjectUtils.removeQueryItem$1(a0, a1);
	}

	static getMeasures(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getMeasures$0(a0);
		}
		return MoserObjectUtils.getMeasures$1(a0);
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/MoserObjectUtils.js